module.exports = __webpack_public_path__ + "static/media/close.068082c4.svg";